import { Button, Modal, ModalActions } from '@braskai/ui-kit';

import { ModalHeaderDefault } from '@/shared/ui/modal';

type DeleteConfirmationModalProps = {
  isLoading: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onDelete: () => void;
};

export const DeleteConfirmationModal = ({ isLoading, isOpen, onCancel, onDelete }: DeleteConfirmationModalProps) => {
  return (
    <Modal open={isOpen} size="xs" onClose={onCancel}>
      <ModalHeaderDefault
        title="Would you like to permanently delete this Teamspace?"
        style={{
          paddingBottom: 0,
        }}
        subtitle="Once you delete it, you and your team will permanently lose access to all projects in this Teamspace."
        onClose={onCancel}
      />
      <ModalActions>
        <Button size="lg" variant="outlined" fullWidth onClick={onCancel}>
          Cancel
        </Button>
        <Button isLoading={isLoading} size="lg" variant="error" fullWidth onClick={onDelete}>
          Delete
        </Button>
      </ModalActions>
    </Modal>
  );
};
